<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
              <div class="form-group">
                <label class="col-form-label" ngbTooltip="field to edit">Offer name<span style="color:red">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="offerEdit.offerName">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-1 col-md-2 col-3">
                <div class="form-group">
                  <label class="col-form-label">Payout $  </label>
                  <input type="text" class="form-control" placeholder="payout.." value="{{offer.payout}}" disabled>
                </div>
            </div>

            <div class="col-lg-2 col-md-3 col-6">
              <div class="form-group">
                  <label class="col-form-label">Advertiser</label>
                  <input type="text" class="form-control" placeholder="Advertiser.." value="{{offer.advertisername}}" disabled>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-12">
              <div class="form-group">
                  <label class="col-form-label">Advertiser offer ID</label>
                  <input type="text" class="form-control" placeholder="Advertiser offer id.." value="{{offer.advertiserOfferId}}" disabled>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-12">
                <div class="form-group">
                    <label class="col-form-label">System offer ID</label>
                    <input type="text" class="form-control" placeholder="Advertiser offer id.." value="{{offer.offerId}}" disabled>
                  </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12">
              <div class="form-group">
                  <i class="flag-icon flag-icon-{{offer.countryalpha2Code | lowercase}}"></i>&nbsp;
                  <label class="col-form-label">Country</label>
                  <input type="text" class="form-control" placeholder="country.." value="{{offer.countryname}}" disabled>
              </div>
            </div>

            <div class="col-lg-2 col-md-3 col-4">
              <div class="form-group">
                <label class="col-form-label">Type</label><br>
                <ul>
                  <li><i class="icofont icofont-ui-check"></i>&nbsp;
                    <span *ngIf="offer.offerCategoryId==1">
                      Click&nbsp;
                    </span>
                    <span *ngIf="offer.offerCategoryId==2">
                      Credit Card Submit&nbsp;
                    </span>
                    <span *ngIf="offer.offerCategoryId==3">
                      Download&nbsp;
                    </span>
                    <span *ngIf="offer.offerCategoryId==4">
                      Email/Zip Submit&nbsp;
                    </span>
                    <span *ngIf="offer.offerCategoryId==5">
                      Mobile install&nbsp;
                    </span>
                    <span *ngIf="offer.offerCategoryId==6">
                      PIN Submit&nbsp;
                    </span>
                    <span *ngIf="offer.offerCategoryId==7">
                      Trial&nbsp;
                    </span>
                    <span *ngIf="offer.offerCategoryId==8">
                      WAP Billing&nbsp;
                    </span>
                    <span  *ngIf="offer.offerCategoryId==9">
                      Other&nbsp;
                    </span>
                  </li>
                  </ul>
              </div>
            </div>

            <div class="col-lg-3 col-md-4 col-4">
              <div class="form-group">
                <label class="col-form-label">Availabe on Devices</label><br>
                <span *ngFor="let dev of offer.offerDevices">
                  <i class="fa fa-mobile-phone" style="font-size: 2.0em;" name="phone" ngbTooltip="phone" *ngIf="dev.name=='Phone'">&nbsp;</i>
                  <i class="fa fa-tablet" style="font-size: 2.0em;" name="tablet" ngbTooltip="tablet" *ngIf="dev.name=='Tablet'">&nbsp;</i>
                  <i class="fa fa-desktop" style="font-size: 2.0em;" name="desktop" ngbTooltip="desktop" *ngIf="dev.name=='Desktop'">&nbsp;</i>
                  <i class="fa fa-gamepad" style="font-size: 2.0em;" name="game" ngbTooltip="game console" *ngIf="dev.name=='Game console'">&nbsp;</i>
                  <i class="fa fa-film" style="font-size: 2.0em;" name="tv" ngbTooltip="TV" *ngIf="dev.name=='Tv'">&nbsp;</i>
                  </span>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
              <div class="form-group">
                <label class="col-form-label">URL</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" ngbTooltip="link to offer" (click)="onUrl()"><i data-feather="external-link"></i></span>
                  </div>
                  <input type="url" class="form-control" placeholder="url.." value="{{offer.offerUrl}}" disabled>
                </div>
              </div>

              <div class="form-group">
                <label class="col-form-label">Preview URL</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" ngbTooltip="link to offer preview" (click)="onPreviewUrl()"><i data-feather="external-link"></i></span>
                  </div>
                  <input type="url" class="form-control" placeholder="preview url.." value="{{offer.offerPreviewUrl}}" disabled>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-1 col-md-1 col-3">
              <div class="form-group">
                <label class="col-form-label" ngbTooltip="0 is switched off" >CAP<span style="color:red">*</span></label>
                <input type="number" class="form-control" min="0" placeholder="cap.." [(ngModel)]="offerEdit.offerCap">
              </div>
            </div>

            <div class="col-lg-5 col-md-12 col-12">
              <div class="form-group">
                <label class="col-form-label"  ngbTooltip="field to edit">Locking title<span style="color:red">*</span></label>
                <input type="text" class="form-control" placeholder="title.." [(ngModel)]="offerEdit.offerLockingTitle">
              </div>
            </div>

            <div class="col-lg-6 col-md-12 col-12">
              <div class="form-group">
                <label class="col-form-label" ngbTooltip="field to edit">Locking description<span style="color:red">*</span></label>
                <textarea type="text" class="form-control" placeholder="description.." [(ngModel)]="offerEdit.offerLockingDescription"></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4 col-md-4 col-4" *ngIf="offer.offerPublisherStatus.length>0">
              <div class="form-group">
                <label class="col-form-label"><i class="fa fa-exclamation-triangle">&nbsp;</i>Offer is disabled by Publishers</label><br>
                <span *ngFor="let publisher of offer.offerPublisherStatus">
                  <a href="adm/publishers/{{ publisher.publisherId }}">{{publisher.publisherName}} | </a>
                </span>
              </div>
            </div>

        </div>
        <div class="btn-showcase">
            <button class="btn btn-sm btn-pill btn-primary" type="button" ngbTooltip="return to offers list"
              (click)="onCancel()">Cancel</button>
            <button class="btn btn-sm btn-pill btn-primary" type="button" ngbTooltip="save data"
              (click)="onSave()" *ngIf="offer.offerGlobalStatus!='Expired'">Update</button>

            <button class="btn btn-sm btn-pill btn-primary" type="button" *ngIf="offer.offerGlobalStatus=='Expired'" disabled>Expired</button>
            <button class="btn btn-sm btn-pill btn-success" type="button" ngbTooltip="offer status on/off" *ngIf="offer.offerGlobalStatus=='Active'"
                  (click)="onStatus()">Active</button>
            <button class="btn btn-sm btn-pill btn-danger" type="button" ngbTooltip="offer status on/off" *ngIf="offer.offerGlobalStatus=='Disabled'"
                  (click)="onStatus()">Disabled</button>
        </div>
      </div>
</div>
<!-- Container-fluid Ends-->
